<template>
    <div id="images" class="col-md-8 col-sm-12" v-if="activePartnumber != null">
        <img class="img-responsive" :src="activePartnumber.ImageLarge" :srcset="activePartnumber.ImageMain + ' 768w,' + activePartnumber.ImageLarge + ' 1199w,'" fetchpriority="high">
        <ul id="thumb-images" style="text-align:center;">
            <li v-for="(image, imageIndex) in activePartnumber.Thumbs" :key="imageIndex">
                <button :href="image.Zoom" data-fancybox="productphotos" class="productzoom vue-enabled" aria-label="Zoom">
                    <img :src="image.Thumb" />
                </button>
            </li>
        </ul>
    </div>
    <div class="col-md-4 col-sm-12 question-container">
        <div><h2>{{title}}</h2></div>
        <div v-for="(question, questionIndex) in questions" :key="questionIndex" class="question">
            <p class="subheading">
                <span class="headinglabel">{{ question.Name }}</span>
                <span class="headingvalue" v-show="question.ShowValueAsTitle == true && selected[question.Name] != undefined">
                    -
                    <strong>{{getAnswerValue(question)?.Name}}</strong>
                    <!--reset enkel indien er geen default value is opgegeven-->
                    <!--<span v-show="questions.length > 1 && (questionIndex > 0 || containsDefaultValue == false)">
                    - <a href="javascript:void(0)" v-on:click="resetQuestion(questionIndex)">reset</a>
                </span>-->
                </span>
            </p>

            <div v-show="question.isVisible==true">
                <!--Dropdown: 1-->
                <div v-if="question.InputField === 'dropdown'" class="bootstrapSelect">
                    <select v-model="selected[question.Name]" class="selectpicker" @change="openNext(questionIndex)">
                        <option v-for="(value, valueIndex) in question.Values" :key="valueIndex" :value="value.Id" v-bind="{ disabled: question.DisableUnavailableValues == true && questions.length > 1 && answerContainsPartnumbers(value) == false ? '' : null }" v-show="question.HideUnavailableValues == false || questions.length > 1 && answerContainsPartnumbers(value) == true" :data-content="value.Name"></option>
                    </select>
                </div>
                <!--Color: 2-->
                <div v-if="question.InputField === 'color'" class="colors">
                    <template v-for="(value, valueIndex) in question.Values" :key="valueIndex">
                        <input type="radio" name="color" :value="value.Id" :id="'radio' + value.Name" v-model="selected[question.Name]" v-bind="{ disabled: question.DisableUnavailableValues == true && questions.length > 1 && answerContainsPartnumbers(value) == false ? '' : null }" v-show="question.HideUnavailableValues == false || questions.length > 1 && answerContainsPartnumbers(value) == true" @change="openNext(questionIndex)" />
                        <label :for="'radio' + value.Name" :class="color == value.Name ? 'selected' : ''" :title="value.Name" v-show="question.HideUnavailableValues == false || questions.length > 1 && answerContainsPartnumbers(value) == true">
                            <i class="icongiant-check"></i>
                            <span class="circle-border">
                                <span class="circle" :style="{ backgroundColor: '#'+value.HexCodePrimary }"></span>
                                <!--show disabled-->
                                <div v-show="questions.length > 1 && answerContainsPartnumbers(value) == false" class="cross1"></div>
                                <div v-show="questions.length > 1 && answerContainsPartnumbers(value) == false" class="cross2"></div>
                                <span class="halfcircle" :style="{ backgroundColor: '#'+value.HexCodeSecondary }"></span>
                            </span>
                        </label>
                    </template>
                </div>
                <!--Buttons: 3-->
                <div v-if="question.InputField === 'button'" class="clearfix buttons">
                    <template v-for="(value, valueIndex) in question.Values" :key="valueIndex">
                        <input type="radio" class="btn-check" v-model="selected[question.Name]" name="options" :value="value.Id" :id="question.Name + '-' + value.Id" @change="openNext(questionIndex)" autocomplete="off" v-bind="{ disabled: question.DisableUnavailableValues == true && questions.length > 1 && answerContainsPartnumbers(value) == false ? '' : null }" v-show="question.HideUnavailableValues == false || questions.length > 1 && answerContainsPartnumbers(value) == true">
                        <label :for="question.Name + '-' + value.Id" class="btn btn-primary" :class="selected[question.Name] === value.Id ? 'selected' : ''" v-show="question.HideUnavailableValues == false || questions.length > 1 && answerContainsPartnumbers(value) == true" v-bind="{ disabled: question.DisableUnavailableValues == true && questions.length > 1 && answerContainsPartnumbers(value) == false ? '' : null }">{{ value.Name }}</label>
                    </template>
                </div>
                <!--Radiobutton: 0-->
                <div v-if="question.InputField === 'radiobutton'" class="radiobuttons">
                    <label v-for="(value, valueIndex) in question.Values" :key="valueIndex">
                        <input type="radio" v-model="selected[question.Name]" :value="value.Id" v-bind="{ disabled: question.DisableUnavailableValues == true && questions.length > 1 && answerContainsPartnumbers(value) == false ? '' : null }" v-show="question.HideUnavailableValues == false || questions.length > 1 && answerContainsPartnumbers(value) == true" @change="openNext(questionIndex)">
                        {{ value.Name }}
                    </label>
                </div>
            </div>
            <div v-show="getAnswerValue(question)?.LabelResult != null">
                <div class="text-right">
                    <span v-html="getAnswerValue(question)?.LabelResult"></span>
                </div>
            </div>
        </div>

        <div v-show="selectedPartnumberCode != ''">
            <SelectedPartnumber></SelectedPartnumber>
            <StockContainer></StockContainer>
        </div>
        <div v-show="selectedPartnumberCode == ''">
            <p v-show="showLabelRequiredPartnumber == true" class="alert alert-danger">{{getInterfaceText('shop_please_select_a_size')}}</p>
            <p class="add-to-cart">
                <button class="btn btn-addtocart" v-on:click="showLabelRequiredPartnumber = true">{{getInterfaceText('add_to_cart')}}</button>
            </p>
        </div>
        <PaymentPromotions :activePartnumber="activePartnumber"></PaymentPromotions>
        <TopBars></TopBars>

        <!--<div v-show="possiblePartnumberCodes().length > 0">
        <h3>Partnumbers:</h3>
        <p v-show="selectedPartnumberCode.length > 0"><a href="javascript:void(0);" v-on:click="resetPartnumber()">Reset</a></p>
        <label v-for="(partnumber, partnumberIndex) in possiblePartnumberCodes()" :key="partnumberIndex" style="display:block;font-weight:normal;">
            <input type="radio" v-model="selectedPartnumberCode" name="partnumbercode" :value="partnumber">
            <span style="font-weight:bold;padding-left:10px;">{{ getPartnumber(partnumber).Code }}</span> - <span>{{ getPartnumber(partnumber).Size }}</span> - <span>{{ getPartnumber(partnumber).Color }}</span> - <span>{{ getPartnumber(partnumber).Price }}</span> - <span>{{ getPartnumber(partnumber).Stock }}</span>
        </label>
    </div>-->
    </div>
</template>

<script>
    import axios from 'axios';
    import vueStore from '../../store/store.js';
    import cartMixin from '../../mixins/cart-mixin.js';
    import generalMixin from '../../mixins/general.js';
    import SelectedPartnumber from '@/components/SelectedPartnumber.vue';
    import StockContainer from '@/components/StockContainer.vue';
    import PaymentPromotions from '@/components/PaymentPromotions.vue';
    import TopBars from '@/components/TopBars.vue';

    export default {
        mixins: [cartMixin, generalMixin],
        data: function () {
            return {
                questions: window.combinationsData,
                partnumbers: window.partnumberData,
                selected: {},
                selectedPartnumberCode: '',
                culture: window.culture,
                title: '',
                showLabelRequiredPartnumber: false
            }
        },
        components: {
            SelectedPartnumber,
            StockContainer,
            PaymentPromotions,
            TopBars
        },
        methods: {
            answerContainsPartnumbers(answer) {
                if (this.selectedAnswers.length == 0) {
                    //no option selected. So all available
                    return true;
                } else {
                    var questionId = answer?.Question?.Id;
                    if (questionId == null)
                        questionId = this.getQuestionByAnswerValue(answer)?.Id;
                    return answer.PartnumberCodes.some(item => this.possiblePartnumberCodes(questionId).includes(item))
                }
            },
            possiblePartnumberCodes(excludeQuestionId) {
                if (this.selectedPartnumber != null && this.selectedPartnumberCode.length > 0 && excludeQuestionId == null) {
                    return [this.selectedPartnumberCode];
                }

                var result = [];

                if (this.selectedAnswers.length > 0) {
                    for (var i = 0; i < this.selectedAnswers.length; i++) {
                        if (excludeQuestionId == null || this.selectedAnswers[i].Question.Id != excludeQuestionId) {
                            if (result.length == 0) {
                                //add all partnumbers
                                result = result.concat(this.selectedAnswers[i].PartnumberCodes);
                            } else {
                                //add only duplicate partnumbers
                                result = result.filter(item => this.selectedAnswers[i].PartnumberCodes.includes(item));
                            }
                        }
                    }
                } else {
                    //no answers selected => default
                    result = this.partnumbers.map(p => p.Code);
                }

                return result;
            },
            getPartnumber(code) {
                return this.partnumbers.find(x => x.Code === code);
            },
            getQuestion(name) {
                return this.questions.find(q => q.Name === name);
            },
            getQuestionByAnswerValue(answer) {
                return this.questions.find(q => q.Values.some(option => option.Id === answer.Id));
            },
            getAnswerValue(question) {
                if (this.selected[question.Name] != undefined) {
                    return this.getQuestion(question.Name)?.Values.find(s => s.Id === this.selected[question.Name]);
                }
                return null;
            },
            resetQuestion(currentIndex) {
                //rest all questions after this index
                for (var i = currentIndex; i < this.questions.length; i++) {
                    eval('delete this.selected.' + this.questions[i].Name);
                }
                //close all other questions
                this.questions.forEach(item => {
                    if (item.AlwaysOpen == false) {
                        item.isVisible = false;
                    }
                });
                //set current question to visible
                this.questions[currentIndex - 1].isVisible = true;

                //set selected partnumber to ''
                this.selectedPartnumberCode = '';

                this.showLabelRequiredPartnumber = false;
            },
            resetPartnumber() {
                this.selectedPartnumberCode = '';
            },
            openNext(currentIndex) {
                //reset next answers first
                this.resetQuestion(currentIndex + 1);

                // Check if there is a next question in the list
                if (currentIndex + 1 < this.questions.length) {
                    this.questions[currentIndex + 1].isVisible = true;
                    if (this.questions[currentIndex].AlwaysOpen == false) {
                        this.questions[currentIndex].isVisible = false;
                    }
                }

                //set value if only one
                if (this.questions[currentIndex + 1] != null) {
                    var values = [];
                    for (var i = 0; i < this.questions[currentIndex + 1].Values.length; i++) {
                        if (this.answerContainsPartnumbers(this.questions[currentIndex + 1].Values[i])) {
                            values.push(this.questions[currentIndex + 1].Values[i]);
                        }
                    }
                    if (values.length == 1) {
                        this.selected[this.questions[currentIndex + 1].Name] = values[0].Id;
                    }
                }

                //set partnumber if only 1
                if (this.possiblePartnumbers.length == 1) {
                    this.selectedPartnumberCode = this.possiblePartnumbers[0];
                }
            },
            async fetchApi() {
                if (this.selectedPartnumber != null) {
                    await axios.get(this.apiUrl)
                        .then((response) => {
                            vueStore.commit('setProduct', response.data)

                            //set default values
                            var partnumber = response.data.Partnumbers?.filter(x => x.code == this.selectedPartnumberCode)
                            if (partnumber.length > 0) {
                                vueStore.commit('setPartnumber', partnumber[0]);
                                //this.color = partnumber[0].color;
                            }
                        })
                }
            },
            redirectToProduct() {
                window.location = '/' + window.culture + '/' + this.product?.Product?.UrlLabel + '?partnumber=' + this.partnumber.code;
            }
        },
        computed: {
            selectedAnswers() {
                var result = [];
                var propNames = Object.keys(this.selected);
                for (var i = 0; i < propNames.length; i++) {
                    const question = this.getQuestion(propNames[i]);
                    const answer = this.getAnswerValue(question);
                    answer.Question = question;
                    result.push(answer);
                }

                return result;
            },
            selectedPartnumber() {
                if (this.selectedPartnumberCode != null) {
                    return this.getPartnumber(this.selectedPartnumberCode);
                }
                return null;
            },
            activePartnumber() {
                return this.selectedPartnumber ?? this.getPartnumber(this.possiblePartnumberCodes()[0]);
            },
            apiUrl() {
                return '/' + window.culture + '/shop/productselector/' + this.selectedPartnumber.ProductId + '/' + this.selectedPartnumber.ProductType + '/true'
            },
            partnumber() {
                return vueStore.state.partnumber
            },
            product() {
                return vueStore.state.product
            },
            containsDefaultValue() {
                return this.questions[0].Values.some(value => value.Default === true);
            },
            possiblePartnumbers() {
                return this.possiblePartnumberCodes();
            }
        },
        beforeMount() {
            for (var i = 0; i < this.questions.length; i++) {
                if (i == 0 || this.questions[i].AlwaysOpen == true) {
                    this.questions[i].isVisible = true;
                } else {
                    this.questions[i].isVisible = false;
                }

                //set default
                if (i == 0 && this.containsDefaultValue) {
                    this.selected[this.questions[i].Name] = this.questions[i].Values.find(value => value.Default === true).Id;

                    //set value of next question if only one
                    var values = [];
                    for (var j = 0; j < this.questions[1].Values.length; j++) {
                        if (this.answerContainsPartnumbers(this.questions[1].Values[j])) {
                            values.push(this.questions[1].Values[j]);
                        }
                    }
                    if (values.length == 1) {
                        this.selected[this.questions[1].Name] = values[0].Id;
                    }
                }
            }
        },
        watch: {
            possiblePartnumbers(newValue, oldValue) {
                if (newValue.length == 1 && (newValue[0] != oldValue[0] || this.selectedPartnumberCode.length == 0)) {
                    //partnumber chosen. Get all data and start e-commerce
                    this.selectedPartnumberCode = newValue[0];
                    this.fetchApi();
                }
            }
        },

        created() {
            this.interfaceTexts = JSON.parse(document.getElementById('vue-parameters').dataset.interfacetexts);
            this.title = document.getElementById('vue-parameters').dataset.title;
        }
    }
</script>
